import { useContext } from 'react';
import { EditorPageContext } from './EditorPageContext';

export const useEditorPageContext = () => useContext(EditorPageContext);
